<template>
  <generic-trash
    v-model="selected"
    :getPag="getPagAux"
    :getExcel="getExcelAux"
    :getParams="getParamsAux"
    :doRestore="doRestoreAux"
    :doDelete="doDeleteAux"
    :FilterPanel="FilterPanel"
    :RouteName="RouteName"
    :dialogTitle="dialogTitle"
    :dialogMesage="dialogMesage"
    :ExcelName="ExcelName"
    :idVista="idVista"
    :HeaderTitle="HeaderTitle"
    :vuexnamespace="vuexnamespace"
    :PayloadSingleId="PayloadSingleId"
    :PayloadMultipleId="PayloadMultipleId"
  />
</template>

<script>
import { i18n } from '@/i18n'
import GenericTrash from '@/views/trash/GenericTrash.vue'
import CustomFilter from '@/components/filters/trash/CompaniesFilter.vue'
import { getCompanies } from '@/services/companies/getCompanies'
import { downloadExcel } from '@/services/companies/downloadExcel'
import { deleteTrashCompany } from '@/services/trash/deleteTrashCompany'
import { restoreTrashCompany } from '@/services/trash/restoreTrashCompany'

export default {
  name: 'vista-papelera-empresas',
  components: {
    GenericTrash,
  },
  data: function () {
    return {
      FilterPanel: CustomFilter,
      RouteName: 'companies',
      dialogTitle: i18n.t('companies.delete_company'),
      dialogMesage: i18n.t('app.delete_permanent_selected_confirmation_f', { entity: i18n.tc('companies.entity_name', 2).toLowerCase() }),
      ExcelName: 'empresas-borrados.xlsx',
      idVista: 27,
      HeaderTitle: i18n.t('trash.companies'),
      vuexnamespace: 'trashCompanies',
      PayloadSingleId: 'IdCIFEmpresa',
      PayloadMultipleId: 'idCifsEmpresa',
      selected: []
    }
  },
  methods: {
    getParamsAux (data) {
      const user = this.$store.getters['auth/user']
      return {
        idUsuario: user.IdUsuario,
        CIF: data.cif ? data.cif.value : null,
        razonSocial: data.name ? data.name.value : null,
        fechaAltaDesde: data.fechaAltaDesde ? data.fechaAltaDesde.value : null,
        fechaAltaHasta: data.fechaAltaHasta ? data.fechaAltaHasta.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        estado: data.estado ? data.estado.value : null,
        email: data.email ? data.email.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
      }
    },
    getParamsMultipleAux: function (data) {
      const params = {}
      if (data.ActiveReports) {
        params.ActiveReports = data.ActiveReports.value
      }
      return params
    },
    getPagAux: async function (objOrder, params) {
      return await getCompanies(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await downloadExcel(objOrder, params)
    },
    doRestoreAux: async function (payload) {
      return await restoreTrashCompany(payload)
    },
    doDeleteAux: async function (payload) {
      return await deleteTrashCompany(payload)
    },
  }
}
</script>
